import PanelLayout from '@amzn/awsui-components-core/panel-layout';
import React from 'react';
import { useAskQuick } from './AskQuickContext';
import { ASK_QUICK_CHAT_URL } from 'src/constants/AppConstants';

import './AskQuickPanel.scss';

interface AskQuickPanelProps {
  children: React.ReactNode;
}

export const AskQuickPanel: React.FC<AskQuickPanelProps> = ({ children }) => {
  const { isOpen, panelSize, onPanelResize, minPanelSize, maxPanelSize } = useAskQuick();

  return (
    <PanelLayout
      display={isOpen ? 'all' : 'main-only'}
      panelPosition="side-end"
      resizable={true}
      panelSize={panelSize}
      minPanelSize={minPanelSize}
      maxPanelSize={maxPanelSize}
      onPanelResize={({ detail }) => onPanelResize(detail.panelSize)}
      i18nStrings={{
        resizeHandleAriaLabel: 'Resize QuickSuite panel',
        resizeHandleTooltipText: 'Drag to resize'
      }}
      mainContent={children}
      panelContent={
        isOpen ? (
          <div className="ask-quick-panel">
            <iframe
              className="ask-quick-panel__iframe"
              src={ASK_QUICK_CHAT_URL.default}
              title="Ask Quick Chat Agent"
              allow="clipboard-read https://us-east-1.quicksight.aws.amazon.com; clipboard-write https://us-east-1.quicksight.aws.amazon.com"
            />
          </div>
        ) : null
      }
    />
  );
};
